import api from '../../utils/api';

// Interface for vendor profile
export interface VendorProfile {
  name: string;
  email: string;
}

// Interface for vendor data
export interface VendorData {
  vendorId: string;
  vendorRole: number;
  phoneNumber: string;
  email: string;
  status: string;
  generatedId: string;
  isActive: boolean;
  createdAt: string;
}

// Interface for vendor with category and profile
export interface VendorWithDetails {
  vendor: VendorData;
  category: string;
  profile: VendorProfile;
}

// Interface for sales executive details
export interface SalesExecutiveDetails {
  id: string;
  name: string;
  email: string;
  role: string;
  department: string;
  phone: string;
  status: string;
  created_by: string;
  last_login_at: string;
  profile_image: string;
  createdAt: string;
  updatedAt: string;
}

// Interface for the complete API response
export interface SalesExecutiveDetailsResponse {
  salesExecutive: SalesExecutiveDetails;
  vendors: VendorWithDetails[];
}

// Fetch sales executive details with vendors
export const fetchSalesExecutiveDetailsWithVendors = async (salesExecutiveId: string): Promise<SalesExecutiveDetailsResponse> => {
  try {
    const response = await api.get(`/master-admin/sales-executive-dashobard/${salesExecutiveId}/details-with-vendors`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sales executive details with vendors:', error);
    throw error;
  }
}; 